const config = {
    ipinfo: 'enterYourToken',
};

export default config;